import _ from 'lodash'
import { validate } from './validations'
import { build } from '../../services/crudFactory'
import { Action } from '../../services/actions.factory'
import apiService from '../../services/api.service'
import { messageActions } from '../../store/message/index'
import storage from '../../services/stoage.service'
import utils from '../../utils'

const BASE_PATH = '/lottustech/notasfiscaisservico'
const crud = build(validate, BASE_PATH)
const prefix = 'crudNfse'

const newTypes = {
  SET_BOOLEAN_FILTER: `${prefix}setBooleanFilter`,
  RESET: `${prefix}reset`,
}

const actions = new Action(prefix, crud)
const types = Object.assign({}, actions.types, newTypes)

actions.setBooleanFilter = (field, value) => {
  return {
    type: types.SET_BOOLEAN_FILTER,
    field,
    value,
  }
}

actions.reset = () => {
  return {
    type: types.RESET,
  }
}

actions.downloadDanfSe = (oidNFSe) => {
  return (dispatch, getState) => {
    if (!oidNFSe) {
      // Sempre uma promise: quem chama encadeia o fim do loading no finally.
      return Promise.resolve()
    }
    // O emissor pode levar mais de um minuto para montar o PDF. Sem este aviso a tela fica
    // parada e parece travada. Fica fixo (sticky) porque some antes do fim da espera se
    // expirar sozinho — quem o remove e o desfecho, abaixo.
    dispatch(messageActions.messageShowMessages(makeMessages([getLabelNfse('nfse.label.solicitandoDanfe')], 'warn')))
    return apiService
      .get(`${BASE_PATH}/downloadDanfSe/${oidNFSe}`)
      .then((response) => {
        downloadDanfSeResponse(response.data, 'DanfSe - ' + oidNFSe + '.pdf')
        dispatch(messageActions.messageClearMessages())
        dispatch(
          messageActions.messageShowMessages(makeMessages([getLabelNfse('nfse.label.danfeConcluida')], 'success'))
        )
      })
      .catch((err) => {
        dispatch(messageActions.messageClearMessages())
        if (err.response) {
          const messages = err.response.data
          dispatch(messageActions.messageShowMessages(makeMessages([messages], 'error')))
        }
      })
  }
}

actions.downloadDanfSePorLancamento = (oidLancamento) => {
  return (dispatch, getState) => {
    if (oidLancamento) {
      dispatch(messageActions.messageShowMessages(makeMessages(['Solicitando nota fiscal!'], 'warn')))
      return apiService
        .get(`${BASE_PATH}/downloadDanfSePorLancamento/${oidLancamento}`)
        .then((response) => {
          const arrayBase64Notas = response.data
          let cont = 1
          arrayBase64Notas.forEach((danfse) => {
            downloadDanfSeResponse(danfse, 'DanfSe - ' + oidLancamento + cont + '.pdf')
            cont++
          })
          // O aviso de espera e sticky; quem o remove e o desfecho.
          dispatch(messageActions.messageClearMessages())
          dispatch(messageActions.messageShowMessages(makeMessages(['Sucesso no download da nota fiscal!'], 'success')))
        })
        .catch((err) => {
          dispatch(messageActions.messageClearMessages())
          if (err.response) {
            const messages = err.response.data
            dispatch(messageActions.messageShowMessages(makeMessages([messages], 'error')))
          }
        })
    }
  }
}
/** As mensagens da lista de erros que o reenvio devolve ([{ oidLancamento, erro }]); vazia quando deu certo. */
export const errosDoReenvio = (dados) =>
  (Array.isArray(dados) ? dados : []).map((item) => item && item.erro).filter((erro) => !!erro)

actions.reenviarNFS = (oidNFSe) => {
  return (dispatch, getState) => {
    if (oidNFSe) {
      return apiService.post(`${BASE_PATH}/reenviarnfs/${oidNFSe}`).then((response) => {
        // o back responde 200 tambem quando o reenvio falha, com a lista de erros no corpo
        const erros = errosDoReenvio(response.data)
        if (erros.length > 0) {
          dispatch(messageActions.messageShowMessages(makeMessages(erros, 'error')))
        } else {
          dispatch(messageActions.messageShowMessages(makeMessages(['Nota reenviada com sucesso!'], 'success')))
        }
        // a nota muda nos dois casos (status e chave, ou o novo motivo da falha)
        dispatch(actions.loadById(oidNFSe))
      })
    }
  }
}

actions.cancelarNFS = (oidNFSe) => {
  return (dispatch, getState) => {
    if (oidNFSe) {
      return apiService
        .post(`${BASE_PATH}/cancelarNFS/${oidNFSe}`)
        .then((response) => {
          dispatch(messageActions.messageShowMessages(makeMessages(['Nota cancelada com sucesso!'], 'success')))
          dispatch(actions.loadById(oidNFSe))
        })
        .catch((err) => {
          if (err.response) {
            const messages = err.response.data
            dispatch(messageActions.messageShowMessages(makeMessages([messages], 'error')))
          }
        })
    }
  }
}

actions.enviarDanfeEmail = (oidNFSe) => {
  return (dispatch, getState) => {
    if (oidNFSe) {
      return apiService
        .post(`${BASE_PATH}/${oidNFSe}/enviar-email`)
        .then((response) => {
          const destinatario = response.data
          const mensagem = destinatario
            ? `Envio da nota por email agendado para ${destinatario}`
            : 'Envio da nota por email agendado'
          dispatch(messageActions.messageShowMessages(makeMessages([mensagem], 'success')))
        })
        .catch((err) => {
          if (err.response) {
            const messages = err.response.data
            dispatch(messageActions.messageShowMessages(makeMessages([messages], 'error')))
          }
        })
    }
  }
}

// O retorno do sincronizar tem tres desfechos e dois eram silenciosos: a prefeitura pode responder
// sem status/numero/data, ou nao responder. Antes a tela dizia "Operação finalizada" nos tres casos.
const resumoSincronizacao = (data) => {
  const total = _.get(data, 'total', 0)
  const atualizadas = _.get(data, 'atualizadas', 0)
  const semRetorno = _.get(data, 'semRetorno', 0)
  const comErro = _.get(data, 'comErro', 0)

  if (total === 1) {
    if (atualizadas === 1) return { texto: 'Nota sincronizada com a prefeitura.', severidade: 'success' }
    if (semRetorno === 1) return { texto: 'A prefeitura respondeu sem dados da nota. Tente novamente mais tarde.', severidade: 'warn' }
    return { texto: 'Não foi possível sincronizar a nota.', severidade: 'error' }
  }

  const partes = [`${atualizadas} de ${total} notas sincronizadas`]
  if (semRetorno > 0) partes.push(`${semRetorno} sem retorno da prefeitura`)
  if (comErro > 0) partes.push(`${comErro} com erro`)
  return {
    texto: `${partes.join('. ')}.`,
    severidade: atualizadas === 0 ? 'error' : (semRetorno > 0 || comErro > 0 ? 'warn' : 'success'),
  }
}

actions.sincronizarNFS = (oidNFSe) => {
  return (dispatch, getState) => {
    if (oidNFSe) {
      return apiService
        .put(`${BASE_PATH}/sincronizar`, [oidNFSe])
        .then((response) => {
          const resumo = resumoSincronizacao(_.get(response, 'data', {}))
          dispatch(messageActions.messageShowMessages(makeMessages([resumo.texto], resumo.severidade)))
          dispatch(actions.loadById(oidNFSe))
        })
        .catch((err) => {
          if (err.response) {
            const messages = err.response.data
            dispatch(messageActions.messageShowMessages(makeMessages([messages], 'error')))
          }
        })
    }
  }
}

// Aviso da propria tela (selecao acima do teto configurado), sem ida ao servidor.
actions.avisar = (texto, severidade = 'warn') => {
  return (dispatch, getState) => {
    dispatch(messageActions.messageShowMessages(makeMessages([texto], severidade)))
  }
}

actions.sincronizarNFSLote = (oidsNFSe) => {
  return (dispatch, getState) => {
    if (!oidsNFSe || oidsNFSe.length === 0) {
      return
    }
    return apiService
      .put(`${BASE_PATH}/sincronizar`, oidsNFSe)
      .then((response) => {
        const resumo = resumoSincronizacao(_.get(response, 'data', {}))
        dispatch(messageActions.messageShowMessages(makeMessages([resumo.texto], resumo.severidade)))
        dispatch(actions.load())
      })
      .catch((err) => {
        const messages = _.get(err, 'response.data', 'Não foi possível sincronizar as notas.')
        dispatch(messageActions.messageShowMessages(makeMessages([messages], 'error')))
      })
  }
}

// Textos vem do dicionario (tela 'nfse'); o fallback cobre base sem a migration aplicada, para
// a tela nunca mostrar aviso em branco.
const LABELS_PADRAO_NFSE = {
  'nfse.label.solicitandoDanfe':
    'Solicitação enviada. A geração da nota pelo emissor pode levar algum tempo — aguarde sem fechar a tela.',
  'nfse.label.danfeConcluida': 'Download da nota concluído.',
}

const getLabelNfse = (codigo) => {
  return utils.getMessage(storage.getAppLabels('nfse'), codigo) || LABELS_PADRAO_NFSE[codigo]
}

const makeMessages = (messages, type) => {
  let sticky = false
  let summary = 'Sucesso! '
  if (type === 'error') {
    summary = 'Erro!'
    sticky = true
  } else if (type === 'warn') {
    summary = 'Atenção!'
    // Espera longa: o aviso tem que continuar na tela ate o download terminar.
    sticky = true
  }
  return messages.map((message) => {
    return { sticky: sticky, summary: summary, severity: type, detail: message }
  })
}

function base64ToArrayBuffer(base64) {
  const binaryString = window.atob(base64)
  const bytes = new Uint8Array(binaryString.length)
  return bytes.map((byte, i) => binaryString.charCodeAt(i))
}

function downloadDanfSeResponse(danfse, filename) {
  if (isReportUrl(danfse)) {
    window.open(danfse, '_blank')
    return
  }
  const arrayBuffer = base64ToArrayBuffer(danfse)
  createAndDownloadBlobFile(arrayBuffer, filename)
}

function isReportUrl(value) {
  return typeof value === 'string' && /^(https?:\/\/|\/)/i.test(value)
}

function createAndDownloadBlobFile(body, filename) {
  const blob = new Blob([body])
  if (navigator.msSaveBlob) {
    // IE 10+
    navigator.msSaveBlob(blob, filename)
  } else {
    const link = document.createElement('a')
    // Browsers that support HTML5 download attribute
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob)
      link.setAttribute('href', url)
      link.setAttribute('download', filename)
      link.style.visibility = 'hidden'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
}

export { types, actions }
